import {Component, effect, inject} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {MatError, MatFormField, MatFormFieldModule, MatHint, MatLabel} from "@angular/material/form-field";
import {MatOption} from "@angular/material/core";
import {MatSelect, MatSelectModule} from "@angular/material/select";
import {MatButton, MatButtonModule} from '@angular/material/button';
import {Store} from '@ngrx/store';
import {PaperChatFilterType} from '../../../chat/dto/paper-chat';
import {selectFilterType} from '../../../chat/service/paper-chat.selector';
import {setChatFilterType} from '../../../chat/service/paper-chat.actions';

import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ResearchExportType} from '../../dto/research-paper';
import {downloadBibtex, downloadCSV} from '../../services/download/file-download.actions';
import {CloseableDialogComponent} from '../../../../utils/components/closeable-dialog/closeable-dialog.component';

interface Option {
  value: string;
  viewValue: string;
}


interface ExportResultDialogData {
  projectId: number;
}

@Component({
  selector: 'app-export-result-dialog',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    CloseableDialogComponent
],
  templateUrl: './export-result-dialog.component.html',
  styleUrl: './export-result-dialog.component.scss'
})
export class ExportResultDialogComponent {
  private readonly store: Store = inject(Store);
  private readonly fb: FormBuilder = inject(FormBuilder);
  private readonly dialogRef: MatDialogRef<ExportResultDialogComponent> = inject(MatDialogRef);
  readonly data: ExportResultDialogData = inject<ExportResultDialogData>(MAT_DIALOG_DATA);

  fileFormat: Option[] = [
    {value: ResearchExportType.BIBTEX, viewValue: 'bibtex'},
    {value: ResearchExportType.CSV, viewValue: 'CSV'},
  ];

  options: Option[] = [
    {value: PaperChatFilterType.ALL, viewValue: 'All'},
    {value: PaperChatFilterType.SCREENING_ONE, viewValue: 'Passed Title/Abstract screening'},
    {value: PaperChatFilterType.SCREENING_TWO, viewValue: 'Passed Full-Text screening'}
  ];
  form: FormGroup = this.fb.group(
    {
      paperFilterSelect: ['', Validators.required],
      fileformat: ['', Validators.required]
    }
  );

  readonly filterType = this.store.selectSignal(selectFilterType());

  constructor() {
    effect(() => {
      this.form.patchValue({paperFilterSelect: this.filterType()}, {emitEvent: false});
    });
  }

  export(): void {
    if(this.form.invalid) {
      return;
    }
    if(this.form.value.fileformat === ResearchExportType.BIBTEX) {
      this.store.dispatch(() => downloadBibtex({
        projectId: this.data.projectId,
        filter: this.form.value.paperFilterSelect
      }));
    }else{
      this.store.dispatch(() => downloadCSV({
        projectId: this.data.projectId,
        filter: this.form.value.paperFilterSelect
      }));
    }
    this.dialogRef.close(true);
  }

}
